const data = {
  'Selected': 'Selecionado: {0} de {1}',
  'Uploading files': 'Fazendo o upload {0}% de {1}',
  'File size error': '{0} é muito grande, por favor faça o upload de arquivos menores do que {1}',
  'Upload failed': '{0} falhou ao fazer o upload',
  'Per page': '{0} Por Página',
  'Folder': 'Pasta',
  'Login failed, please try again': 'Login falhou, por favor tente novamente.',
  'Already logged in': 'Já está logado.',
  'Please enter username and password': 'Por favor entre com o nome de usuário e senha.',
  'Not Found': 'Não Encontrado',
  'Not Allowed': 'Não Autorizado',
  'Please log in': 'Por favor, faça o login',
  'Unknown error': 'Erro desconhecido',
  'Add files': 'Adicionar arquivos',
  'New': 'Novo',
  'New name': 'Novo nome',
  'Username': 'Nome de usuário',
  'Password': 'Senha',
  'Login': 'Entrar',
  'Logout': 'Sair',
  'Profile': 'Perfil',
  'No pagination': 'Sem Paginação',
  'Time': 'Tempo',
  'Name': 'Nome',
  'Size': 'Tamanho',
  'Home': 'Página inicial',
  'Copy': 'Copiar',
  'Move': 'Mover',
  'Rename': 'Renomear',
  'Required': 'Por favor preencha este campo',
  'Zip': 'Comprimir',
  'Batch Download': 'Download em lotes',
  'Unzip': 'Descomprimir',
  'Delete': 'Deletar',
  'Download': 'Download',
  'Copy link': 'Copiar link',
  'Done': 'Finalizado',
  'File': 'Arquivo',
  'Drop files to upload': 'Arraste arquivos para fazer o upload',
  'Close': 'Fechar',
  'Select Folder': 'Selecionar Pasta',
  'Users': 'Usuários',
  'Files': 'Arquivos',
  'Role': 'Posição',
  'Cancel': 'Cancelar',
  'Paused': 'Parado',
  'Confirm': 'Confirmar',
  'Create': 'Criar',
  'User': 'Usuário',
  'Admin': 'Administrador',
  'Save': 'Salvar',
  'Read': 'Ler',
  'Write': 'Escrever',
  'Upload': 'Upload',
  'Permissions': 'Permissões',
  'Homedir': 'Pasta da página inicial',
  'Leave blank for no change': 'Deixe em branco para não fazer nenhuma alteração',
  'Are you sure you want to do this?': 'Tem certeza que deseja fazer isto?',
  'Are you sure you want to allow access to everyone?': 'Tem certeza que deseja permitir o acesso a todos?',
  'Are you sure you want to stop all uploads?': 'Tem certeza que deseja parar todos os uploads?',
  'Something went wrong': 'Algo deu errado',
  'Invalid directory': 'Diretório inválido',
  'This field is required': 'Este arquivo é obrigatório',
  'Username already taken': 'O nome de usuário já existe',
  'User not found': 'Usuário não encontrado',
  'Old password': 'Senha atual',
  'New password': 'Nova senha',
  'Wrong password': 'Senha inválida',
  'Updated': 'Atualizado',
  'Deleted': 'Excluido',
  'Your file is ready': 'Seu arquivo está pronto',
  'View': 'View',
  'Search': 'Search',
  'Download permission': 'Download',
  'Guest': 'Guest',
}

export default data

